import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getUserTeams } from '../../utils/api-helper';

const initialState = {
  teams: [],
  loading: false,
  error: null
};

export const fetchUserAccessTeam = createAsyncThunk(
  'userAccessTeamList/fetchUserAccessTeam',
  async () => {
    const response = await getUserTeams();
    return response.data;
  }
);

export const userAccessTeam = createSlice({
  name: 'userAccessTeamList',
  initialState,
  reducers: {
    setUserAccessTeam: (state, action) => {
      state.teams = action?.payload;
    },
    updateUserAccessTeam: (state, action) => {
      state.teams = action?.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserAccessTeam.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserAccessTeam.fulfilled, (state, action) => {
        state.loading = false;
        state.teams = action.payload;
      })
      .addCase(fetchUserAccessTeam.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export const { setUserAccessTeam, setAssetMapping, updateUserAccessTeam } =
  userAccessTeam?.actions;

export default userAccessTeam?.reducer;
